import React, { useState, useEffect } from 'react';
import '../../../urunDiv.css';
import './KahveDetay.css';
import iceAmericano from '../../../../assets/menu/icecekler/soguk-kahveler/ice-americano.jpeg';

const IceAmericano = () => {
  const [selectedShot, setSelectedShot] = useState('Double Shot');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsPhone(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const shotOptions = [
    { name: 'Single Shot', price: 0 },
    { name: 'Double Shot', price: 0 },
    { name: 'Ekstra Shot', price: 50 }
  ];

  const handleShotChange = (shot) => {
    setSelectedShot(shot);
    setIsDropdownOpen(false);
  };

  const basePrice = 175.00;
  const selectedShotPrice = shotOptions.find(shot => shot.name === selectedShot)?.price || 0;
  const totalPrice = basePrice + selectedShotPrice;

  const kahve = {
    name: 'İce Americano',
    price: '₺209,90',
    image: iceAmericano,
    description: 'Espresso, su ve buz'
  };

  return isPhone ? (
    <div className="americano-detay-container">
      <div className="product-section">
        <div className="product-image-container">
          <img src={kahve.image} alt={kahve.name} className="product-image" />
                      <div className="product-overlay">
              <div className="product-name-price">{kahve.name} - ₺{totalPrice.toFixed(2)}</div>
            </div>
        </div>
                  <div className="product-description">
            <p>{kahve.description}</p>
          </div>

          {/* Espresso Shot Options */}
          <div className="shot-options">
            <h3>Shot Seçenekleri</h3>
            <div className="dropdown-container">
              <div 
                className="dropdown-header"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <span>{selectedShot}</span>
                <span className="dropdown-arrow">▼</span>
              </div>
              {isDropdownOpen && (
                <div className="dropdown-options">
                  {shotOptions.map((option) => (
                    <div 
                      key={option.name}
                      className={`dropdown-option ${selectedShot === option.name ? 'selected' : ''}`}
                      onClick={() => handleShotChange(option.name)}
                    >
                      <span>{option.name}</span>
                      {option.price > 0 && <span className="option-price">₺{option.price}</span>}
                      {selectedShot === option.name && <span className="checkmark">✓</span>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
  ) : (
    <div className="urun-detay-container-computer">
      <div className="product-section">
        <div className="product-image-container">
          <img src={kahve.image} alt={kahve.name} className="product-image" />
                      <div className="product-overlay">
              <div className="product-name-price">{kahve.name} - ₺{totalPrice.toFixed(2)}</div>
            </div>
        </div>
        <div className="product-description-computer">
          <p>{kahve.description}</p>
        </div>

        {/* Espresso Shot Options */}
        <div className="shot-options">
          <h3>Shot Seçenekleri</h3>
          <div className="dropdown-container">
            <div 
              className="dropdown-header"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>{selectedShot}</span>
              <span className="dropdown-arrow">▼</span>
            </div>
            {isDropdownOpen && (
              <div className="dropdown-options">
                {shotOptions.map((option) => (
                  <div 
                    key={option.name}
                    className={`dropdown-option ${selectedShot === option.name ? 'selected' : ''}`}
                    onClick={() => handleShotChange(option.name)}
                  >
                    <span>{option.name}</span>
                    {option.price > 0 && <span className="option-price">₺{option.price}</span>}
                    {selectedShot === option.name && <span className="checkmark">✓</span>}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IceAmericano;
